function zoom(_val) {
  const types = ['normal', 'brush'];
  if (!arguments.length) return this.__attrs__.zoom;
  if (typeof _val === 'boolean') {
    if (_val) this.__attrs__.zoom = 'normal'; //brush 인 경우 있음
    else this.__attrs__.zoom = false;
  } else if (typeof _val === 'string') {
    if (types.findIndex(d => d.localeCompare(_val) === 0) >= 0) {
      this.__attrs__.zoom = _val;
    }
  } 
  
  return this;
}

export default zoom;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/zoomable/zoom.js